export const creacionDivLeyenda = (
  contenedorCapa,
  layerSource,
  layerName,
  view
) => {
  //div leyenda
  const contenedorLegend = document.createElement("div");
  contenedorLegend.className = "capas-activas-panel-leyenda";

  const newLegend = document.createElement("img");
  //id único
  newLegend.id = "legend-" + layerName;
  newLegend.alt = "Leyenda de " + layerName;

  //agrega la imagen nueva a la legenda

  if (layerSource) {
    const resolution = view.getResolution();
    const graphicUrl = layerSource.getLegendUrl(resolution);
    newLegend.src = graphicUrl;
  }
  contenedorLegend.appendChild(newLegend);
  contenedorCapa.appendChild(contenedorLegend);
};
